import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SirketBilgileriPage = () => {
  const [form, setForm] = useState({ sirket_adi: '', adres: '', yetkili_ad: '', yetkili_unvan: '', telefon: '', email: '', vergi_no: '', ticaret_sicil: '' });
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);

  useEffect(() => {
    axios.get('/api/admin/sirket-bilgileri').then(r => setForm(r.data)).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/admin/sirket-bilgileri', form);
      setSonuc({ tip: 'basari', mesaj: 'Şirket bilgileri güncellendi.' });
    } catch(err) {
      setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' });
    } finally { setYukleniyor(false); }
  };

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Şirket Bilgileri</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Belgelerde kullanılacak şirket bilgilerini güncelleyin.</p>
      </div>
      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}
      <div className="card">
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.25rem' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '1rem' }}>Şirket Bilgileri</p>
            <div className="form-grid">
              <div className="form-group full"><label>Şirket Adı *</label><input type="text" value={form.sirket_adi} onChange={e => setForm({ ...form, sirket_adi: e.target.value })} required placeholder="Valure Teknoloji A.Ş." /></div>
              <div className="form-group full"><label>Adres *</label><textarea value={form.adres} onChange={e => setForm({ ...form, adres: e.target.value })} rows={2} placeholder="Gelincik Sk No:18 D:216, 34746 Ataşehir/İstanbul" /></div>
              <div className="form-group"><label>Vergi No</label><input type="text" value={form.vergi_no} onChange={e => setForm({ ...form, vergi_no: e.target.value })} /></div>
              <div className="form-group"><label>Ticaret Sicil No</label><input type="text" value={form.ticaret_sicil} onChange={e => setForm({ ...form, ticaret_sicil: e.target.value })} /></div>
              <div className="form-group"><label>Telefon</label><input type="text" value={form.telefon} onChange={e => setForm({ ...form, telefon: e.target.value })} /></div>
              <div className="form-group"><label>E-posta</label><input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
            </div>
          </div>
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1.25rem', marginBottom: '1.25rem' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '1rem' }}>Yetkili Kişi</p>
            <div className="form-grid">
              <div className="form-group"><label>Ad Soyad *</label><input type="text" value={form.yetkili_ad} onChange={e => setForm({ ...form, yetkili_ad: e.target.value })} required placeholder="Orhan Karaman" /></div>
              <div className="form-group"><label>Unvan *</label><input type="text" value={form.yetkili_unvan} onChange={e => setForm({ ...form, yetkili_unvan: e.target.value })} required placeholder="Genel Müdür" /></div>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
        </form>
      </div>
    </div>
  );
};
export default SirketBilgileriPage;
